import './App.css';
import Home from './components/Home/Home';
import Header from './components/Header/Header';

function App() {
  return (
    <div className="App mt-5">
      <Header></Header>
      <Home></Home>
    </div>
  );
}

export default App;
